import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  { icon: FiIcons.FiLink, title: "One Click, Infinite Reach", description: "Instantly generate high-converting event URLs. Share unique, short links across any platform to track performance and drive direct registrations." },
  { icon: FiIcons.FiSend, title: "Omnichannel Promotion", description: "Broadcast your event to social channels and email lists simultaneously. Our integrated tools ensure your message lands exactly where your audience lives." },
  { icon: FiIcons.FiGrid, title: "Curated Event Series", description: "Don't just promote one event—showcase your entire seasonal lineup. Group collections into beautiful galleries that encourage multi-event signups." },
  { icon: FiIcons.FiLayout, title: "Native Website Embedding", description: "Turn your existing website into a powerful sales engine. Embed ticketing and event info directly into your pages with a single line of code." },
  { icon: FiIcons.FiSmartphone, title: "Brand-First Mobile Widgets", description: "Fully customizable, mobile-optimized widgets that feel like a native part of your site. Maintain total brand control while maximizing mobile conversions." }
];

const UnityPromotion = () => {
  return (
    <section id="promotion" className="py-24 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-emerald-600 tracking-wide uppercase">Promotion & Embedding</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl"> Share Everywhere. Grow Faster. </p>
          <p className="mt-4 max-w-2xl text-xl text-slate-500 mx-auto"> Eliminate the technical barriers to event marketing. Unity gives you the tools to be omnipresent without the overhead. </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div key={index} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} viewport={{ once: true }} className="bg-white p-8 rounded-3xl border border-slate-200 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 group" >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-emerald-600 rounded-2xl shadow-lg group-hover:rotate-6 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-4">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm"> {feature.description} </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UnityPromotion;